export const PANE_COLUMNS = {
  form: "md:grid-cols-1",
  list: "md:grid-cols-[minmax(240px,280px)_minmax(0,1fr)]",
  conversation:
    "md:grid-cols-[minmax(240px,280px)_minmax(0,1fr)] lg:grid-cols-[minmax(160px,0.8fr)_minmax(0,1.4fr)_minmax(220px,1fr)] min-[90rem]:grid-cols-[minmax(240px,280px)_minmax(0,1fr)_minmax(280px,330px)]",
  queue:
    "md:grid-cols-[minmax(240px,280px)_minmax(190px,230px)_minmax(0,1fr)] lg:grid-cols-[minmax(140px,0.7fr)_minmax(120px,0.6fr)_minmax(0,1.3fr)_minmax(220px,1fr)] min-[90rem]:grid-cols-[minmax(240px,280px)_minmax(190px,230px)_minmax(0,1fr)_minmax(280px,330px)]",
} as const;
